import React from "react";
import { Modal } from "seed/helpers";
import { resolveFileUrl } from "components/brief/util/fileUrl";

const RevisionMockups = ({
  mockups,
  activeMockupIdx,
  canNavigateMockups,
  currentMockup,
  currentAnnotations,
  annotationNumbers,
  allowComments,
  onClickPrevMockup,
  onClickNextMockup,
  onChangeCurrentAnnotations,
  currentAuthor,
  ImageAnnotator,
  isDeveloper,
  isFullscreenOpen,
  onClickOpenFullscreen,
  onClickCloseFullscreen,
}) => {
  const currentMockupUrl = resolveFileUrl(currentMockup.url);

  const renderAnnotator = () => {
    if (!currentMockupUrl) {
      return (
        <div className="p-2 text-center rounded">
          <i className="fas fa-image fa-3x text-muted mb-3"></i>
        </div>
      );
    }

    return (
      <ImageAnnotator
        src={currentMockupUrl}
        annotations={currentAnnotations}
        annotationNumbers={annotationNumbers}
        onChange={onChangeCurrentAnnotations}
        isEditable={allowComments}
        currentAuthor={currentAuthor}
        defaultAnnotationData={{
          visibility_scope: isDeveloper ? "DEV" : "CLIENT",
          is_solved: false,
        }}
      />
    );
  };

  return (
    <>
      <div className="revision-mockup h-100 p-0 pb-3 pb-md-0 d-flex flex-column overflow-auto"
        style={{ scrollbarColor: "#ffffff40 #00000012", flexGrow: 3, borderRadius: "0.5rem", border: "1px solid #ffffff40" }}>
        {mockups.length > 1 && (
          <div className="p-3 border-bottom sticky-top d-flex justify-content-between align-items-center">
            <div className="d-flex justify-content-between align-items-center w-100">

              {canNavigateMockups && (
                <div className="d-flex align-items-center bg-light rounded border">
                  <button type="button" className="btn btn-xs btn-white border-0" disabled={activeMockupIdx === 0} onClick={onClickPrevMockup}>
                    <i className="fas fa-chevron-left text-primary"></i>
                  </button>

                  <span className="small font-weight-bold mx-2">
                    {activeMockupIdx + 1} / {mockups.length}
                  </span>

                  <button
                    type="button"
                    className="btn btn-xs btn-white border-0"
                    disabled={activeMockupIdx === mockups.length - 1}
                    onClick={onClickNextMockup}
                  >
                    <i className="fas fa-chevron-right text-primary"></i>
                  </button>
                </div>
              )}
            </div>
          </div>
        )}

        <div className="w-100 h-100 d-flex align-items-center border-0"
          style={{ minHeight: 0, backgroundColor: "#000" }}>
          <div className="w-100 h-100">
            <div key={currentMockupUrl} className="position-relative rounded overflow-hidden animate__animated animate__fadeIn">
              {renderAnnotator()}

              {currentMockupUrl &&
                <button
                  type="button"
                  className="fullscreen-button btn btn-sm btn-primary position-absolute"
                  style={{
                    right: "0%", bottom: "0%",
                    marginRight: "15px", marginBottom: "15px",
                    zIndex: 20, borderRadius: "100%",
                    opacity: "0.4",
                    width: "60px", height: "60px", fontSize: "1.45rem"
                  }}
                  onClick={onClickOpenFullscreen}
                >
                  <i className="fas fa-expand"></i>
                </button>
              }
            </div>

            {currentMockup.caption && (
              <div
                className="px-3 py-3 text-muted rounded border"
                style={{ lineHeight: "1.7", whiteSpace: "normal", wordBreak: "break-word", overflowWrap: "anywhere" }}
                dangerouslySetInnerHTML={{ __html: currentMockup.caption }}
              />
            )}
          </div>
        </div>
      </div>

      {isFullscreenOpen &&
        <Modal width={1500} height={950} overflow="hidden" onClose={onClickCloseFullscreen}>
          <div className="w-100 h-100 position-relative">
            <div className="w-100 h-100 overflow-auto p-0"
              style={{ scrollbarColor: "#ffffff40 #00000012" }}>
              {renderAnnotator()}
            </div>
          </div>
        </Modal>
      }
    </>
  );
};

export default RevisionMockups;
